export const infoTitleMap = {
    '#0': ' - 寶寶專區',
    '#1': ' - 幼兒專區',
    '#3': ' - 幼童專區',
    '#6': ' - 學齡後兒童',
    '#n': ' - 新手爸媽區',
    default: '',
};

export const getInfoTitles = (hash: string): string =>
{
    const prefix = '衛教專區';
    return `${prefix}${infoTitleMap[hash] || infoTitleMap.default}`;
}